import { action, makeObservable, observable } from "mobx";

class PagerStore<T> {
    numPages = 0;
    currentPage = 0;
    itemsPerPage = 5;
    hasLoaded = false;

    //Start item
    firstItemIndex = 0;

    protected _numberOfItems = 0;

    items: Array<T> = [];

    pageItems: Array<T> = [];

    constructor(itemsPerPage = 5) {
        this.itemsPerPage = itemsPerPage;

        makeObservable(this, {
            numPages: observable,
            currentPage: observable,
            itemsPerPage: observable,
            hasLoaded: observable,
            firstItemIndex: observable,
            items: observable,
            pageItems: observable,
            updateItems: action,
            updateCurrentPage: action
        });
    }

    reset() {
        console.log("Reset");
        this.currentPage = 0;
        this.firstItemIndex = 0;
    }

    clear() {
        this.items = [];
        this.pageItems = []
        this.reset();
    }

    updateItems(value: Array<T>) {
        this.items = value;

        this._numberOfItems = this.items?.length ?? 0;

        this.numPages = this._numberOfItems > 0 ? Math.ceil(this._numberOfItems / this.itemsPerPage) : 0;

        this.hasLoaded = true;

        this.updateCurrentPage(0);
    }

    updateCurrentPage(value: number) {
        this.currentPage = value;

        const startIndex = (value * this.itemsPerPage) % this._numberOfItems;
        const endIndex = startIndex + this.itemsPerPage;

        this.pageItems = this.items?.slice(startIndex, endIndex) ?? []
    }

    get hasItems() {
        return this.hasLoaded && this.items?.length > 0;
    }
}

export default PagerStore;
